export const colors =  {
    voteFor: "#009688",
    voteAgainst: "#E91E63",
    voteAbstain: "#FF9800",
    voteExtraOption: "#42a5f5",
    null: "#1D529C",
};